class AthleteFilter extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
    this.onChange = this.onChange.bind(this);
    this.checkboxes.forEach((cb) => cb.addEventListener('change', this.onChange));
  }

  onChange() {
    // Get selected filters
    const selectedDisciplines = Array.from(this.querySelectorAll('input[data-type="discipline"]:checked')).map((cb) =>
      cb.value.toLowerCase()
    );

    const selectedCountries = Array.from(this.querySelectorAll('input[data-type="country"]:checked')).map((cb) =>
      cb.value.toLowerCase()
    );

    console.log('Selected Disciplines:', selectedDisciplines);
    console.log('Selected Countries:', selectedCountries);

    const cards = document.querySelectorAll('.athlete-card');

    cards.forEach((card) => {
      const cardDisciplines = (card.dataset.discipline || '')
        .toLowerCase()
        .split(',')
        .map((d) => d.trim());
      const cardCountry = (card.dataset.country || '').toLowerCase().trim();

      const matchDiscipline =
        selectedDisciplines.length === 0 || selectedDisciplines.some((filter) => cardDisciplines.includes(filter));

      const matchCountry = selectedCountries.length === 0 || selectedCountries.includes(cardCountry);

      const showCard = matchDiscipline && matchCountry;

      card.classList.toggle('hidden', !showCard);
    });
  }
}

if (!customElements.get('athlete-filter')) {
  customElements.define('athlete-filter', AthleteFilter);
}
